import { Heading } from '@zillow/constellation-10';
import styled from 'styled-components';

export const ZillowNavbarSubSectionTitle = styled(Heading)`
    font-size: 14px;
    line-height: 40px;
`;
